import { configureStore } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistReducer, persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import affilitateReducer from './reducers/affilitate';
import agentReducer from './reducers/agent';
import paymentReducer from './reducers/payment';
import personalDetailReducer from './reducers/personal-detail';
import planSummaryReducer from './reducers/plan-summary';
import uiStateReducer from './reducers/ui-state';
// import storageSession from 'reduxjs-toolkit-persist/lib/storage/session';

const persistConfig = {
  key: 'root',
  storage: storageSession,
};

const persistedAgentReducer = persistReducer(persistConfig, agentReducer);
const persistedAfilitatorReducer = persistReducer(
  persistConfig,

  affilitateReducer,
);

export const store = configureStore({
  reducer: {
    personalDetail: personalDetailReducer,
    planSummary: planSummaryReducer,
    uiState: uiStateReducer,
    payment: paymentReducer,
    agent: persistedAgentReducer,
    affilitator: persistedAfilitatorReducer,
  },
  devTools: process.env.NODE_ENV === 'development',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
